/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdDomainSettingsCompanyBrandingConfig, FxIdDomainSettingsCompanyBrandingConfigFromJSONTyped, FxIdDomainSettingsCompanyBrandingConfigToJSON, } from './FxIdDomainSettingsCompanyBrandingConfig';
export function FxIdDomainSettingsPortalPublicWebConfigOptionsCompanyBrandingFromJSON(json) {
    return FxIdDomainSettingsPortalPublicWebConfigOptionsCompanyBrandingFromJSONTyped(json, false);
}
export function FxIdDomainSettingsPortalPublicWebConfigOptionsCompanyBrandingFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdDomainSettingsCompanyBrandingConfig(json)) {
        return FxIdDomainSettingsCompanyBrandingConfigFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdDomainSettingsPortalPublicWebConfigOptionsCompanyBrandingToJSON(json) {
    return FxIdDomainSettingsPortalPublicWebConfigOptionsCompanyBrandingToJSONTyped(json, false);
}
export function FxIdDomainSettingsPortalPublicWebConfigOptionsCompanyBrandingToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdDomainSettingsCompanyBrandingConfig(value)) {
        return FxIdDomainSettingsCompanyBrandingConfigToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdDomainSettingsPortalPublicWebConfigOptionsCompanyBranding.js.map